import Default from '@app/constants';
import { FilterEvLockerLogs } from '@app/typings/services/winnonie/logs';
import { getRowsPerPage } from '@app/utils/localStorage';
import { get, set } from 'lockr';

const filterEvLockerLogsBrand: string = 'winnonie/brand/evLockerLogs.filters';
const filterEvLockerLogsProject: string = 'winnonie/project/evLockerLogs.filters';

const defaultBrandLevel = Default.filter.winnonie.evLockerLogsBrandLevel;
const defaultProjectLevel = Default.filter.winnonie.evLockerLogsProjectLevel;

export const setFilterEvLockerLogsBrandWinnonie = (value: FilterEvLockerLogs) => {
  set(filterEvLockerLogsBrand, value);
};
export const getFilterEvLockerLogsBrandWinnonie = (): FilterEvLockerLogs => {
  return (
    get(filterEvLockerLogsBrand) || {
      filters: defaultBrandLevel,
      pages: Default.pages,
    }
  );
};
export const clearFilterEvLockerLogsBrandWinnonie = () => {
  return set(filterEvLockerLogsBrand, {
    filters: defaultBrandLevel,
    pages: {
      offset: Default.pages.offset,
      limit: getFilterEvLockerLogsBrandWinnonie().pages.limit || Number(getRowsPerPage()),
    },
  });
};
export const setFilterEvLockerLogsProjectWinnonie = (value: FilterEvLockerLogs) => {
  set(filterEvLockerLogsProject, value);
};
export const getFilterEvLockerLogsProjectWinnonie = (): FilterEvLockerLogs => {
  return (
    get(filterEvLockerLogsProject) || {
      filters: defaultProjectLevel,
      pages: Default.pages,
    }
  );
};
export const clearFilterEvLockerLogsProjectWinnonie = () => {
  return set(filterEvLockerLogsProject, {
    filters: defaultProjectLevel,
    pages: {
      offset: Default.pages.offset,
      limit: getFilterEvLockerLogsProjectWinnonie().pages.limit || Number(getRowsPerPage()),
    },
  });
};
